export default __webpack_public_path__ + "static/media/tulufali_logo.dc56e95d.svg";